import { AttentionModal, colors, opacityTransition, sizing } from '@chillibean/component-library';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';

export function WarningNavLink(props) {
  const { children, text, title, to, warning = false } = props;

  const [showWarning, setShowWarning] = useState(false);

  const handleClick = (event) => {
    if (!warning) {
      return;
    }

    event.preventDefault();
    setShowWarning(true);
  };

  const handleDismissWarning = () => {
    setShowWarning(false);
  };

  const handleConfirm = () => {
    setShowWarning(false);
  };

  return (
    <>
      <NavLink activeClassName="active" exact onClick={handleClick} to={to}>
        {children}
      </NavLink>
      <AttentionModal
        confirmButton={
          <StyledNavLink activeClassName="active" exact onClick={handleConfirm} to={to}>
            Confirm
          </StyledNavLink>
        }
        onClose={handleDismissWarning}
        text={text}
        title={title}
        visible={showWarning}
      />
    </>
  );
}

const StyledNavLink = styled(NavLink)`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${sizing.small};
  border: 0;
  border-radius: ${sizing.xsmall};
  user-select: none;
  background-color: ${colors.black.medium};
  color: ${colors.white.primary} !important;
  text-decoration: none;
  padding: ${sizing.lsmall} ${sizing.medium};

  &:hover {
    text-decoration: none;
    color: ${colors.white.primary} !important;
    background-color: ${colors.black.primary};
    ${opacityTransition};
  }
`;

WarningNavLink.propTypes = {
  children: PropTypes.node.isRequired,
  text: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  to: PropTypes.string.isRequired,
  warning: PropTypes.bool,
};

export default WarningNavLink;
